<template>
  <div>
    <div class="content-header">
      <div class="clearfix">
        <h1 class="header-form-loan-info text-uppercase mb-1">{{ $t('lsFundDistributed')}}</h1>
        <h1 class="mb-2">{{totalInvestedAmount | displayAmount('IDR') }}</h1>
        <span class="text-danger" for="">{{dataErr.totalInvestedAmount}}</span>
        <h6 class="mb-2">{{ $t('lsTotalFunds')}} {{totalAmounts | displayAmount('IDR')}}</h6>
        <span class="text-danger" for="">{{dataErr.totalAmounts}}</span>
        <h6 class="mb-2">{{ $t('lsTotalFundsNotDistributed')}} {{totalAvailableAmounts | displayAmount('IDR')}}</h6>
        <span class="text-danger" for="">{{dataErr.totalAvailableAmount}}</span>
        <router-link :to="{name: 'addLoanStatement'}">
         <button type="button" class="btn btn-success mt-3" style="border-radius: 15px">{{ $t('lsDistributeFunds')}}</button>
        </router-link> 
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">

              <v-client-table :data="loanStatements" 
                :columns="tableHeaders"
                :options="options"
              >
              </v-client-table>

              <p class="vue-pagination-ad"></p>
              
            </div>
          </div>
          <h1 class="text-danger">{{dataErr.loanStatement}}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Paginate from '@/components/Paginate.vue'

export default {
  name: 'loanStatement',
  data(){
    return{
      loanStatements:[],
      totalInvestedAmount:0,
      totalAvailableAmounts:0,
      totalAmounts:0,
      dataErr:{
        totalAmounts:"",
        totalInvestedAmount:"",
        totalAvailableAmounts:"",
        loanStatement:""
      },
      tableHeaders: ['loanId', 'product', 'borrower', 'cashingDate', 'amount', 'interest', 'tenor', 'status'],
      options: {
        sortable: ['loanId', 'product', 'borrower', 'cashingDate', 'amount', 'interest', 'tenor', 'status'],
        sortIcon: {
          base : 'fa',
          is: 'fa-sort',
          up: 'fa-sort-up',
          down: 'fa-sort-down'
        },
        headings: {
          'cashingDate': '	Date of Disbursement',
          'amount': 'Principal',
          'interest': 'Interest P.A'
        },
        templates: {
          cashingDate(h, row) {
            return this.$options.filters.displayDate(row.cashingDate)
          },
          amount(h, row) {
            return this.$options.filters.displayAmount(row.amount)
          },
          interest(h, row) {
            return this.$options.filters.displayAmount(row.interest)
          }
        }
      }
    }
  },
  components:{
    Paginate

  },
  created(){
   this.getLoanStatement(),
   this.totalAvailableAmount(),
   this.totalInvested(),
   this.totalAmount()
  },
  methods:{
    getLoanStatement(){
     this.$axios
     .get("admin/v1/priority/loan-statement")
     .then(response =>{
        this.loanStatements = response.data.data
     })
     .catch(error =>{
        this.dataErr.loanStatement = "Data Tidak Dapat Di Tampilkan"
     })
    },
    totalAvailableAmount() { //TOTAL DANA YANG BELUM SALURKAN
      this.$axios
        .get("/admin/v1/priority/investments/total-available-amount")
        .then(response => {
         
          this.totalAvailableAmounts = response.data.data.notInvested;
        })
        .catch(error => {
         this. dataErr.totalAvailableAmounts= "Data Tidak Dapat Di Tampilkan"
        });
    },
    totalInvested() { // TOTAL DANA YANG TELAH DI SALURKAN
      this.$axios
        .get("/admin/v1/priority/investments/total-distributed")
        .then(response => {
          this.totalInvestedAmount = response.data.data[0].value;
        })
        .catch(error => {
          this. dataErr.totalInvestedAmount = "Data Tidak Dapat Di Tampilkan"
        });
    },
    totalAmount() { // TOTAL DANA LENDER PRIORITY
      this.$axios
        .get("/admin/v1/priority/investments/total-amount")
        .then(response => {
          this.totalAmounts = response.data.data.totalDanaLender
          
        })
        .catch(error => {
          this.dataErr.totalAmounts = "Data Tidak Dapat Di Tampilkan"
        });
    }
  }
};
</script>

<style>
</style>
